import { useEffect, useState } from "react";
import { StatusBar, Style } from "@capacitor/status-bar";
import { App } from "@capacitor/app";
import { isNative } from "@/utils/platform";
import { logger } from '@/lib/logger';

export const useCapacitorSetup = () => {
  const [isCapacitorReady, setIsCapacitorReady] = useState(false);

  useEffect(() => {
    const setupCapacitor = async () => {
      try {
        if (isNative()) {
          // Configure status bar
          await StatusBar.setStyle({ style: Style.Default });
          await StatusBar.setBackgroundColor({ color: "#ffffff" });

          // Handle app state changes
          App.addListener("appStateChange", ({ isActive }) => {
            logger.debug('App state changed', { data: { isActive }, component: 'useCapacitorSetup' });
          });

          // Handle back button (Android)
          App.addListener("backButton", ({ canGoBack }) => {
            if (!canGoBack) {
              App.exitApp();
            } else {
              window.history.back();
            }
          });
        }
        setIsCapacitorReady(true);
      } catch (error) {
        logger.error('Capacitor setup failed', { error, component: 'useCapacitorSetup' });
        setIsCapacitorReady(true); // Still mark as ready to not block app
      }
    };

    setupCapacitor();
  }, []);

  return { isCapacitorReady };
}; 